import * as React from "react"
const CardReadIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11.36}
    height={12.77}
    viewBox="0 0 3.006 3.379"
    {...props}
  >
    <path
      d="M4.467-1.267a.05.05 0 1 0-.1 0v.024a.202.202 0 0 0-.125-.042c-.117 0-.239.1-.239.27 0 .153.104.28.233.28A.205.205 0 0 0 4.382-.8c.008.016.018.03.029.043a.145.145 0 0 0 .1.042.217.217 0 0 0 .202-.143.447.447 0 0 0 .023-.296.49.49 0 0 0-.246-.297.496.496 0 0 0-.67.202.49.49 0 0 0-.044.365.498.498 0 0 0 .468.373.052.052 0 0 0 .05-.048c0-.026-.02-.05-.047-.05a.401.401 0 0 1-.111-.78.4.4 0 0 1 .502.264.37.37 0 0 1-.02.233c-.011.024-.04.082-.112.082a.043.043 0 0 1-.029-.013.064.064 0 0 1-.018-.048v-.394Zm-.228.434c-.063 0-.135-.069-.135-.18 0-.111.071-.172.138-.172.066 0 .121.066.124.161v.019c-.003.095-.06.172-.13.172z"
      className="cls-4"
      style={{
        fill: "#010101",
        strokeWidth: 0.264583,
      }}
      transform="translate(-2.768 2.368)"
    />
    <path
      d="M5.76.797V-.891a.218.218 0 0 0-.063-.154l-.193-.19v-.111a.05.05 0 0 0-.05-.05c-.03 0-.05.02-.05.05v.526l-.9.897L4.364 0a.214.214 0 0 0-.204 0l-.14.077-.9-.897v-.854c0-.064.053-.117.116-.117H5.29c.064 0 .117.053.117.117v.116c0 .026.021.05.05.05.03 0 .05-.02.05-.05v-.116a.213.213 0 0 0-.214-.215H4.84l-.432-.423a.211.211 0 0 0-.285 0l-.432.423H3.24a.213.213 0 0 0-.214.215v.439l-.194.19a.218.218 0 0 0-.063.154v.563c0 .027.021.05.05.05.03 0 .05-.02.05-.05V-.89c0-.013.004-.027.009-.04l.166.167.895.891L2.87.715v-.823a.05.05 0 0 0-.05-.05c-.03 0-.05.02-.05.05v.907c0 .117.095.212.211.212h1.826a.05.05 0 0 0 .05-.05c0-.03-.021-.05-.05-.05H2.982a.111.111 0 0 1-.108-.085l1.17-.643.174-.095a.113.113 0 0 1 .108 0l.175.095 1.17.643a.11.11 0 0 1-.109.085h-.534a.05.05 0 0 0-.05.05c0 .029.02.05.05.05h.534A.212.212 0 0 0 5.774.8zM4.186-2.241a.11.11 0 0 1 .15 0l.36.352H3.83l.36-.352zM3.02-.92l-.09-.09.09-.087zm2.469.157.167-.167s.008.027.008.04V.712L4.596.125l.895-.892zm.106-.244-.09.09v-.177z"
      className="cls-4"
      style={{
        fill: "#010101",
        strokeWidth: 0.264583,
      }}
      transform="translate(-2.768 2.368)"
    />
  </svg>
)
export default CardReadIcon
